<template>
  <div>
    <q-card class="marginTag">
      <q-card-section>
        <div class="titleCard">Respuesta</div>
        <div class="row" v-if="isCiudadano || isOnlyAccess">
          {{respuesta}}
        </div>
        <div class="row"  v-else>
          <div class="col-1">
            <q-select
              class="input"
              outlined
              :options="optionsSelect ? optionsSelect : ['No hay opciones']"
              option-value="id"
              option-label="name"
              v-model="respuesta"
              @input="changeSelect()"
            >
            </q-select>
          </div>
        </div>
      </q-card-section>
    </q-card>
  </div>
</template>
<script>
import { mapGetters } from 'vuex';
import * as types from '@/storeModules/NGUD/types';

export default {
  props: {
    dataIndicador: Object
  },
  computed: {
    ...mapGetters({
      isCiudadano: 'NGUD/isCiudadano',
      ciudadSelected: 'NGUD/ciudadData',
      isOnlyAccess: 'NGUD/isOnlyAccess'
    })
  },
  data () {
    return {
      respuesta: '',
      optionsSelect: [{ name: 'Sí', id: 1 }, { name: 'No', id: 2 }]
    };
  },
  created () {
    this.fillData();
  },
  methods: {
    fillData () {
      if (this.dataIndicador.respuesta !== null) {
        this.respuesta = this.dataIndicador.respuesta ? 'Sí' : 'No';
      }
    },
    async changeSelect () {
      let idIndicador = this.$route.params.idIndicador || this.$route.params.idCiudadIndicadorAUE;

      const dataIndicador = {
        idCiudad: this.ciudadSelected.id,
        idIndicador,
        respuesta: this.respuesta.name === 'Sí'
      };

      await this.$store.dispatch(types.ACTION_SAVE_DATOS_CUALITATIVOS, {
        dataIndicador
      }).then(response => {
        // lanzar evento para actualizar gráfica con datos intermedios
        this.$eventHub.$emit('updateIndicadorAUE', response.data.id);
      }).catch((err) => {
        console.log(err);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.marginTag.q-card {
  margin-top: 25px;
  font-family: DINPro;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  .titleCard {
    margin: 0 0px 10px 4px;
    font-size: 20px;
    font-family: DINPro;
    font-weight: bold;
    letter-spacing: 0.29px;
    color: #474848;
  }
}
.row {
  margin-top: 15px;
  font-family: DINPro;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: -1.21px;
  color: #0093b2;
}
</style>
